import { Button } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import { FormButtonsProps } from './types'

const FormButtons = ({ isDisabled, isLoading }: FormButtonsProps) => {
  // i18n
  const { t } = useTranslation('registration')

  return (
    <Button disabled={isDisabled} size="large" loading={isLoading} isFullwidthMobile>
      {t('buttons.next')}
    </Button>
  )
}

export default FormButtons
